import api from '@/lib/api'

export interface MenuItem {
  key: string
  label: string
  icon: string
  permission?: string | null
  children?: MenuItem[]
}

export const getMenu = () =>
  api
    .get<{ success: true; data: MenuItem[] }>('/menu')
    .then((r) => r.data.data ?? [])
